import React from 'react'
import ServicesCards from '../components/serviceCards'
import MATHIMG from '../assets/images/math.svg'

const Services = () => {

    const cards = [
        {
            title: 'Math',
            icon: MATHIMG,
            body: 'Empower your mathematical journey with our specialized math services, tailored for comprehensive understanding and skill enhancement'
        },
        {
            title: 'Physics',
            icon: 'https://researchmethod.net/wp-content/uploads/2022/09/What_is_Physics-1024x576.jpg',
            body: 'Explore the wonders of the physical universe with our simplified physics services, where complex concepts become clear and captivating.'
        },
        {
            title: 'Chemistry',
            icon: 'https://bright-culture.com/wp-content/uploads/2021/06/5-Steps-to-Understand-Chemistry-optimized.png',
            body: 'Dive into the world of atoms and reactions with our easy-to-follow chemistry services, turning the complexities of molecules into understandable and enjoyable lessons.'
        }
    ]

    return (
        <div className='w-full h-auto lg:py-10 py-3 bg-gray-300 lg:px-32 px-5' id='services'>
            <div className='flex flex-col text-center lg:gap-16 gap-8'>
                <h1 className='font-semibold text-4xl text-black'>Services</h1>
                <div className='flex lg:flex-row flex-col gap-5 justify-between text-center items-center'>
                        <ServicesCards cards={cards} />
                </div>
            </div>
        </div>
    )
}

export default Services